"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const app_types_1 = require("pages/app.types");
const toolkit_1 = require("@reduxjs/toolkit");
const pit_operation_types_1 = require("./pit-operation.types");
const initialState = {
    errorCode: 0,
    dataGrid: [],
    isError: false,
    isLoading: true,
    isSuccess: false,
    documentExport: {
        content: '',
        filename: '',
        filetype: '',
    },
    errorMessage: '',
    mutationMode: false,
    isLoadingExportPdf: false,
    isLoadingExportExcel: false,
    dataItem: {
        no: 0,
        id: '',
        dataChild: [],
        area_name: '',
        seam_name: '',
        dump_truck: '',
        modified_by: '',
        excavator_no: '',
        contractor_name: '',
        modified_date: new Date(),
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [
            { field: 'contractor_name', dir: 'asc' },
            { field: 'area_name', dir: 'asc' }
        ]
    }
};
const reportPitOperationReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [pit_operation_types_1.reportPitOperationTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [pit_operation_types_1.reportPitOperationTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [pit_operation_types_1.reportPitOperationTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess, isLoadingExportPdf, isLoadingExportExcel } = action.payload;
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess, isLoadingExportPdf: isLoadingExportPdf ? isLoadingExportPdf : initialState.isLoadingExportPdf, isLoadingExportExcel: isLoadingExportExcel ? isLoadingExportExcel : initialState.isLoadingExportExcel });
    },
    [pit_operation_types_1.reportPitOperationTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id))
                    return dataItem;
                return item;
            }) });
    },
    [pit_operation_types_1.reportPitOperationTypes.SET_ERROR]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isSuccess: false, isLoading: false, isLoadingExportPdf: false, isLoadingExportExcel: false });
    },
    [pit_operation_types_1.reportPitOperationTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [pit_operation_types_1.reportPitOperationTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, sort: action.payload }) });
    },
    [pit_operation_types_1.reportPitOperationTypes.SET_EXPORT_DOCUMENTS]: (state, action) => {
        const { name, type, content } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoadingExportPdf: false, isLoadingExportExcel: false, documentExport: {
                content: content,
                filename: name,
                filetype: type,
            } });
    },
    [pit_operation_types_1.reportPitOperationTypes.CLEAR_EXPORT_DOCUMENTS]: () => {
        return Object.assign(Object.assign({}, initialState), { documentExport: {
                content: '',
                filename: '',
                filetype: '',
            } });
    }
});
exports.default = reportPitOperationReducer;
